(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  var burger = document.getElementById('MobileNavToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq-item.is-open').forEach(function (open) {
        if (open !== item) {
          open.classList.remove('is-open');
          open.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = thumb.dataset.index;
      var gallery = thumb.closest('.product-gallery');
      gallery.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      gallery.querySelectorAll('.product-gallery__slide').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.index === index);
      });
    });
  });

  /* ---------- Variant selection ---------- */
  var variantsJsonEl = document.getElementById('ProductVariantsJson');
  if (variantsJsonEl && productForm) {
    var variants = JSON.parse(variantsJsonEl.textContent);
    var selectedIdInput = document.getElementById('ProductSelectedVariant');
    var addToCartBtn = document.getElementById('AddToCartButton');
    var priceEl = document.getElementById('ProductPrice');

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function currentOptionValues() {
      var values = [];
      productForm.querySelectorAll('.product-form__swatches').forEach(function (group) {
        var checked = group.querySelector('.js-variant-option:checked');
        values[parseInt(group.dataset.optionPosition, 10) - 1] = checked ? checked.value : null;
      });
      return values;
    }

    function findMatchingVariant() {
      var values = currentOptionValues();
      return variants.find(function (v) {
        return [v.option1, v.option2, v.option3].every(function (opt, i) {
          return values[i] === undefined || values[i] === null || opt === values[i];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      selectedIdInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price
          ? '<span class="price price--sale">' + money(variant.price) + '</span>' +
            '<span class="price price--compare">' + money(variant.compare_at_price) + '</span>'
          : '<span class="price">' + money(variant.price) + '</span>';
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? addToCartBtn.dataset.availableText || addToCartBtn.textContent : 'Sold out';
      }
    }

    productForm.querySelectorAll('.js-variant-option').forEach(function (input) {
      input.addEventListener('change', function () {
        applyVariant(findMatchingVariant());
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll('.quantity-stepper__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      var step = parseInt(btn.dataset.step, 10);
      var value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = value;
    });
  });

  /* ---------- Countdown timer ---------- */
  var countdown = document.getElementById('Countdown');
  if (countdown) {
    var storageKey = 'magicBlocCountdownEnd';
    var minutes = parseInt(countdown.dataset.minutes, 10) || 60;
    var end = sessionStorage.getItem(storageKey);
    if (!end || parseInt(end, 10) < Date.now()) {
      end = Date.now() + minutes * 60 * 1000;
      sessionStorage.setItem(storageKey, String(end));
    } else {
      end = parseInt(end, 10);
    }

    var hoursEl = document.getElementById('CountdownHours');
    var minutesEl = document.getElementById('CountdownMinutes');
    var secondsEl = document.getElementById('CountdownSeconds');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var remaining = Math.max(0, end - Date.now());
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
      if (remaining <= 0) clearInterval(interval);
    }

    tick();
    var interval = setInterval(tick, 1000);
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  var stickyBar = document.getElementById('StickyAddToCart');
  var productForm = document.getElementById('ProductForm');
  var stickyBtn = document.getElementById('StickyAddToCartButton');
  if (stickyBar && productForm) {
    var formInView = false;
    function updateSticky() {
      var show = !formInView && window.scrollY > 400;
      stickyBar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { formInView = entry.isIntersecting; });
      updateSticky();
    }, { threshold: 0 });
    observer.observe(productForm);
    window.addEventListener('scroll', updateSticky, { passive: true });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        /* Click the real button so the same "Adding…" state and gift logic run. */
        var mainBtn = document.getElementById('AddToCartButton');
        if (mainBtn) { mainBtn.click(); }
        else { productForm.requestSubmit ? productForm.requestSubmit() : productForm.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
    }
  }

  /* ---------- Demo video: autoplay on screen, pause off screen, tap to pause/play ---------- */
  document.querySelectorAll('[data-demo-video]').forEach(function (box) {
    var v = box.querySelector('video');
    if (!v) return;
    v.muted = true;
    v.defaultMuted = true;
    var onScreen = false;
    var userPaused = false;
    function start() {
      var p = v.play();
      if (p && p.catch) { p.catch(function () { box.classList.add('is-paused'); }); }
    }
    v.addEventListener('playing', function () { box.classList.remove('is-paused'); });
    /* Tap the video to pause it, tap again to play. */
    box.addEventListener('click', function () {
      if (v.paused) { userPaused = false; start(); }
      else { userPaused = true; v.pause(); box.classList.add('is-paused'); }
    });
    if (!('IntersectionObserver' in window)) { start(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        onScreen = entry.isIntersecting;
        if (onScreen) { if (!userPaused) { start(); } }
        else { v.pause(); }
      });
    }, { threshold: 0.1 }).observe(box);
    /* If the browser still blocks autoplay, retry on the first touch/scroll. */
    v.addEventListener('canplay', function () { if (onScreen && v.paused && !userPaused) { start(); } });
    ['touchstart', 'touchend', 'pointerdown', 'scroll', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () {
        if (onScreen && v.paused && !userPaused) { start(); }
      }, { passive: true, once: true });
    });
  });

  /* ---------- Cart drawer + Add to cart ----------
     After "Add to Cart" the drawer opens so the shopper can change their mind.
     +/- buttons change the number of sets instantly (no Update button). The two free
     gifts exist only when there are 2+ sets, and shoppers can't change them directly. */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartDrawerOverlay = document.getElementById('CartDrawerOverlay');
  var cartDrawerClose = document.getElementById('CartDrawerClose');
  var cartDrawerKeep = document.getElementById('CartDrawerKeep');
  var cartDrawerItems = document.getElementById('CartDrawerItems');
  var cartDrawerFooter = document.getElementById('CartDrawerFooter');
  var cartDrawerSubtotal = document.getElementById('CartDrawerSubtotal');
  var cartDrawerSavings = document.getElementById('CartDrawerSavings');
  var cartCount = document.getElementById('CartCount');
  var cartIcon = document.getElementById('CartIcon');

  var MAIN_ID = cartDrawer ? parseInt(cartDrawer.dataset.mainVariant, 10) || 0 : 0;
  var GIFT_IDS = cartDrawer ? (cartDrawer.dataset.giftVariants || '').split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return n > 0; }) : [];
  var MIN_SETS = cartDrawer ? parseInt(cartDrawer.dataset.minSets, 10) || 2 : 2;
  var MAX_SETS = 10;
  var lastSets = 0;
  var busy = false;

  function moneyFormat(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(str) { return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) { throw new Error('cart request failed'); } return r.json(); });
  }
  function qtyOf(cart, variantId) {
    var n = 0;
    cart.items.forEach(function (i) { if (i.variant_id === variantId) { n += i.quantity; } });
    return n;
  }
  function setsIn(cart) { return qtyOf(cart, MAIN_ID); }

  /* Gifts are exactly 1 each when there are 2+ sets, otherwise 0. Called after every change. */
  function syncGifts(cart) {
    if (!MAIN_ID || !GIFT_IDS.length) { return Promise.resolve(cart); }
    var want = setsIn(cart) >= MIN_SETS ? 1 : 0;
    var updates = {};
    var changed = false;
    GIFT_IDS.forEach(function (id) {
      if (qtyOf(cart, id) !== want) { updates[id] = want; changed = true; }
    });
    return changed ? postJSON('/cart/update.js', { updates: updates }) : Promise.resolve(cart);
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    document.body.classList.add('cart-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    if (cartCount) cartCount.textContent = cart.item_count;
    if (!cartDrawerItems) return;
    lastSets = setsIn(cart);
    if (cart.item_count === 0) {
      cartDrawerItems.innerHTML = '<p class="cart-drawer__empty">Your cart is empty 🧺</p>';
      if (cartDrawerFooter) cartDrawerFooter.hidden = true;
      return;
    }
    if (cartDrawerFooter) cartDrawerFooter.hidden = false;

    /* Show the set first and the free gifts after it. */
    var orderedItems = cart.items.slice().sort(function (a, b) {
      return (GIFT_IDS.indexOf(a.variant_id) !== -1 ? 1 : 0) - (GIFT_IDS.indexOf(b.variant_id) !== -1 ? 1 : 0);
    });
    var html = orderedItems.map(function (item) {
      var img = item.image ? '<img src="' + esc(item.image) + '" alt="">' : '';
      var isGift = GIFT_IDS.indexOf(item.variant_id) !== -1;
      if (isGift) {
        return '<div class="cd-item cd-item--gift">' + img +
          '<div class="cd-item__info">' +
            '<strong class="cd-item__title">🎁 ' + esc(item.product_title.replace(/^Free Gift:\s*/i, 'Free gift: ')) + '</strong>' +
            '<div class="cd-item__price"><span class="cd-free">FREE</span></div>' +
            '<p class="cd-gift-note">Free with ' + MIN_SETS + ' or more sets</p>' +
          '</div></div>';
      }
      var priceHtml = moneyFormat(item.final_line_price);
      if (item.original_line_price > item.final_line_price) {
        priceHtml += '<s>' + moneyFormat(item.original_line_price) + '</s>';
      }
      var canStep = item.variant_id === MAIN_ID;
      var stepper = canStep
        ? '<div class="cd-stepper" role="group" aria-label="Number of sets">' +
            '<button type="button" class="cd-stepper__btn" data-action="dec" aria-label="One fewer set"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
            '<span class="cd-stepper__qty">' + item.quantity + (item.quantity === 1 ? ' set' : ' sets') + '</span>' +
            '<button type="button" class="cd-stepper__btn" data-action="inc" aria-label="One more set"' + (item.quantity >= MAX_SETS ? ' disabled' : '') + '>+</button>' +
          '</div>' +
          '<button type="button" class="cd-remove" data-action="remove">Remove</button>'
        : '';
      return '<div class="cd-item">' + img +
        '<div class="cd-item__info">' +
          '<strong class="cd-item__title">' + esc(item.product_title) + '</strong>' +
          '<div class="cd-item__price">' + priceHtml + '</div>' +
          stepper +
        '</div></div>';
    }).join('');

    if (lastSets === 1) {
      html += '<div class="cd-nudge"><p>🎁 Add <strong>1 more set</strong> to <strong>save 15%</strong> and get <strong>2 FREE squishy gifts</strong>.</p>' +
        '<button type="button" class="cd-nudge__btn" data-action="inc">Yes, add 1 more set</button></div>';
    } else if (lastSets >= MIN_SETS) {
      var saved = cart.total_discount > 0 ? ' You\'re saving ' + moneyFormat(cart.total_discount) + ' and getting 2 FREE gifts.' : ' You\'re getting 2 FREE gifts.';
      html += '<div class="cd-nudge cd-nudge--done"><p>🎉 Great choice!' + saved + '</p></div>';
    }
    cartDrawerItems.innerHTML = html;

    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = moneyFormat(cart.total_price);
    if (cartDrawerSavings) {
      if (cart.total_discount > 0) {
        cartDrawerSavings.textContent = 'You save ' + moneyFormat(cart.total_discount);
        cartDrawerSavings.hidden = false;
      } else {
        cartDrawerSavings.hidden = true;
      }
    }
  }

  function refreshCart() {
    return getCart().then(syncGifts).then(function (cart) { renderCartDrawer(cart); return cart; }).catch(function () {});
  }

  /* Change the number of sets (the gifts follow automatically). */
  function setSets(newQty) {
    if (busy || !MAIN_ID) return;
    busy = true;
    cartDrawer.classList.add('is-loading');
    var updates = {};
    updates[MAIN_ID] = newQty;
    GIFT_IDS.forEach(function (id) { updates[id] = newQty >= MIN_SETS ? 1 : 0; });
    postJSON('/cart/update.js', { updates: updates })
      .then(renderCartDrawer)
      .catch(function () { return refreshCart(); })
      .then(function () { busy = false; cartDrawer.classList.remove('is-loading'); });
  }

  if (cartDrawerItems) {
    cartDrawerItems.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn || btn.disabled) return;
      var action = btn.dataset.action;
      if (action === 'inc') { setSets(Math.min(MAX_SETS, lastSets + 1)); }
      else if (action === 'dec') { setSets(Math.max(1, lastSets - 1)); }
      else if (action === 'remove') { setSets(0); }
    });
  }

  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      if (settingsCartIsDrawer()) {
        e.preventDefault();
        openCartDrawer();
        refreshCart();
      }
    });
  }
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerKeep) cartDrawerKeep.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCartDrawer(); } });

  function settingsCartIsDrawer() {
    return document.body.dataset.cartType !== 'page';
  }

  /* On every page load: keep the cart count right, and fix any cart that has gifts
     without 2+ sets (or the other way round). */
  if (cartDrawer && MAIN_ID) { refreshCart(); }

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      /* Apple Pay / Shop Pay / Google Pay render their own button(s) inside this same
         form. Only intercept submits that came from our own Add to Cart button —
         let the express-checkout buttons submit normally so they still work. */
      if (e.submitter && e.submitter.id !== 'AddToCartButton') { return; }
      e.preventDefault();
      var btn = document.getElementById('AddToCartButton');
      var formData = new FormData(productForm);
      var want = parseInt(formData.get('quantity'), 10) || 1;
      if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }

      /* "Add to Cart" sets the number of sets to what was chosen — pressing it twice
         never doubles the order by accident. The shopper can still change it in the cart. */
      getCart()
        .then(function (cart) {
          var have = setsIn(cart);
          if (want > have) {
            /* One request adds the sets and the gifts together (fewer round trips = faster on phones). */
            var updates = {};
            updates[MAIN_ID] = want;
            var giftWant = want >= MIN_SETS ? 1 : 0;
            GIFT_IDS.forEach(function (id) { updates[id] = giftWant; });
            return postJSON('/cart/update.js', { updates: updates });
          }
          return cart;
        })
        .then(syncGifts)
        .then(function (cart) {
          renderCartDrawer(cart);
          openCartDrawer();
        })
        .catch(function () {
          productForm.submit();
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText; }
        });
    });
  }
})();